import {
  InputLabel,
  MenuItem,
  Select,
  SelectChangeEvent,
  TextField,
} from "@mui/material";
import { useRef, useState } from "react";
import { BaseProps } from "src/components/move-inRegistrationTabs/interfaces";
import NocsRequests from "../../stores/NocsRequestsStore";
import General from "../../stores/GeneralStore";
import CloseIcon from "../../assets/CloseIcon.svg";
import { validateDate } from "@mui/x-date-pickers/internals";
import { observer } from "mobx-react";

interface Obj {
  [key: string]: string;
}

interface Props {
  payNow: any;
  closeModal: any;
}

const PendingDuesModal = ({ closeModal, payNow }: Props) => {
  const ColorAss = General?.ColorAss;
  const contrast = General?.contrast;
  return (
    <div
      style={{
        width: General?.isLargeScreen ? "40%" : "100%",
        display: "flex",
        flexDirection: "column",
        backgroundColor: General.contrast.contrastColor
        ? General.contrast.contrastBackground
        : '#fff',
        color: General.contrast.contrastColor
        ? General.contrast.contrastColor
        : General?.ColorAss,
        margin: "10% auto",
        direction: General?.codeLabels["cm_pdc_paymentaccounts"]?.languageCode == "ARA" ? "rtl" : "ltr",
      }}
    >
      <div
        style={{
          // height: '20%',
          width: "100%",
          justifyContent: "space-between",
          paddingLeft: "1rem",
          paddingRight: "1rem",
          background: General.contrast.contrastBackground
            ? General.contrast.contrastColor
            : General?.ColorAss,
          display: "flex",
          alignItems: "center",
        }}

      >
        <h1 style={{
          color: General.contrast.contrastColor
            ? General.contrast.contrastBackground
            : '#fff', justifySelf: "flex-start", fontSize: General?.isLargeScreen ? "" : "2rem"
        }}>
          {General?.codeLabels["cm_proceed_payment"]?.label !== undefined ? General?.codeLabels["cm_proceed_payment"]?.label : "Proceed to payment"}
        </h1>
        <img src={CloseIcon} alt="" onClick={closeModal} />
      </div>
      <div style={{ padding: '1rem' }}>
        <span  style={{ fontSize: `${General.accessibility.fontSize}rem` }}>
          {General?.codeLabels["cm_pend_due"]?.label !== undefined
            ? General?.codeLabels["cm_pend_due"]?.label
            : "Please Pay Pending Due To Proceed Further"}
        </span>
        <br />




        <div style={{ width: '100%', display: "flex", justifyContent: 'space-between' }}>
          <button
            onClick={payNow}
            style={{
              background: General.contrast.contrastColor
                ? General.contrast.contrastColor
                : General?.ColorAss,
              color: General.contrast.contrastColor
                ? General.contrast.contrastBackground
                : '#fff',
              height: "3.5rem",
              width: "12.5rem",
              fontSize: `${1.5 *General.accessibility.fontSize}rem`,
              marginTop: '2rem',
              border: 'none'
            }}

          >
            {General?.codeLabels["cm_paynow"]?.label !== undefined ? General?.codeLabels["cm_paynow"]?.label : "Pay Now"}
          </button>

          <button
            onClick={closeModal}
            style={{
              background: General.contrast.contrastColor
                ? General.contrast.contrastColor
                : General?.ColorAss,
              color: General.contrast.contrastColor
                ? General.contrast.contrastBackground
                : '#fff',
              height: "3.5rem",
              width: "12.5rem",
              fontSize: `${1.5 *General.accessibility.fontSize}rem`,
              marginTop: '2rem',
              border: 'none'
            }}

          >
            {General?.codeLabels["cm_close"]?.label !== undefined ? General?.codeLabels["cm_close"]?.label : "Close"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default observer(PendingDuesModal);
